export const PRIVILEGED_ACCESS_EMAIL = "luke@vicdieselrepairs.com";
export const PRIVILEGED_ACCESS_UID = "teThTf96J5fu5NUrjVGKxTFV96e2";

export function normalizeEmail(value = "") {
  return String(value || "").trim().toLowerCase();
}

export function hasPrivilegedAccess(user) {
  if (!user) return false;

  return (
    user.uid === PRIVILEGED_ACCESS_UID ||
    normalizeEmail(user.email) === PRIVILEGED_ACCESS_EMAIL
  );
}
